import type { HoneycombChartTooltipProps } from '../types/honeycomb-internal.js';

export const Tooltip = (props: HoneycombChartTooltipProps) => null;

Tooltip['displayName'] = 'HoneycombChart.Tooltip';
